import {Component, Input} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';

@Component({
  selector: 'mp-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent {

  @Input()
  public closeMenuCallback: any;

  constructor(private apiService: ApiService, private router: Router) {
  }

  public showLogout(): boolean {
    return this.apiService.currentMieterListValue != null;
  }

  public logout($event: any): void {
    $event.preventDefault();
    this.apiService.resetData();
    this.router.navigate(['login']);
    this.closeMenuCallback();
  }

  public changePassword($event: any): void {
    $event.preventDefault();
    this.router.navigate(['passwort-aendern']);
    this.closeMenuCallback();
  }
}
